import config from '../../../config';
import _ from 'lodash';

const logTypes = { TYPE_AFFILIATE_MARKETING: 'affiliate_marketing', RAKUTEN: 'rakuten' };
const logSources = { SOURCE_AP_FE: 'web', SOURCE_MOBILE: 'mobile', SOURCE_MOBILE_GTM: 'gtm' };
const logLevels = {
    LEVEL_DEBUG: 'debug',
    LEVEL_INFO: 'info',
    LEVEL_NOTICE: 'notice',
    LEVEL_WARNING: 'warning',
    LEVEL_ERROR: 'error',
    LEVEL_CRITICAL: 'critical',
    LEVEL_ALERT: 'alert',
    LEVEL_EMERGENCY: 'emergency',
};

const logData = (
    content,
    orderId = null,
    source = logSources.SOURCE_AP_FE,
    type = logTypes.TYPE_AFFILIATE_MARKETING,
    level = logLevels.LEVEL_DEBUG,
) => {

    let logContnet = {
        ...content,
        storeCode: config.storeCode,
        url: window.location.href
    };

    let payload = {
        content: logContnet,
        orderId: orderId || getOrderId(content),
        level,
        type,
        source
    };

    $.ajax({
        url: `${config.api}/log`,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(payload),
    })
        .done(result => { })
        .fail(err => { });

}

const getOrderId = (payload) => _.get(payload, 'orderConfirmationId', null)
                             || _.get(payload, 'ecommerce.purchase.actionField.id', null)
                             || _.get(payload, 'orderid', null);

window.pbwwLogData = logData;

export {
    logData,
    logTypes,
    logLevels
};



// WEBPACK FOOTER //
// ./src/Common/Providers/LogApi.js